import { Component } from '@angular/core';

@Component({
  templateUrl: './support.page.html',
})
export class SupportPageComponent {}
